export default __webpack_public_path__ + "static/media/bootS.14e7d747.png";